import React from "react";
import { Card, Container } from "react-bootstrap";
import { FaFacebook, FaGoogle, FaYelp, FaStar, FaQuoteRight } from "react-icons/fa";


const reviews = [
  {
    name: "Louisa Sullivan",
    time: "3 days ago",
    rating: 5,
    text: "Amazing coffee at the cozy café! The baristas were passionate about their craft.",
    platform: "facebook",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    bgColor: "#fff",
    textColor: "#333",
    position: { top: "5%", left: "5%" },
  },
  {
    name: "Bobby Henderson",
    time: "3 days ago",
    rating: 5,
    text: "Great quality and value! The T-shirts I bought from this brand are soft, durable, and affordable.soft, durable, and affordable",
    platform: "yelp",
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    bgColor: "#fff",
    textColor: "#333",
    position: { top: "5%", right: "5%" },
  },
  {
    name: "Jasmine Barnett",
    time: "2 minutes ago",
    rating: 5,
    text: "Love these sunglasses! Stylish and provide excellent sun protection.",
    platform: "facebook",
    image: "https://randomuser.me/api/portraits/women/50.jpg",
    bgColor: "#fff",
    textColor: "#333",
    position: { bottom: "10%", left: "10%" },
  },
  {
    name: "Terry Mendez",
    rating: 5,
    text: "I had a fantastic time at the museum. The interactive exhibits made learning fun.",
    platform: "google",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    bgColor: "#fff",
    textColor: "#333",
    position: { bottom: "10%", right: "5%" },
  },
];

const getPlatformIcon = (platform) => {
  switch (platform) {
    case "facebook":
      return <FaFacebook className="ms-2 text-primary" />;
    case "google":
      return <FaGoogle className="ms-2 text-danger" />;
    case "yelp":
      return <FaYelp className="ms-2 text-warning" />;
    default:
      return null;
  }
};

const ReviewCard = ({ review }) => {
  return (
    <Card
      className="review-card shadow-lg p-3 position-absolute"
      style={{
        borderRadius: "15px",
        backgroundColor: review.bgColor,
        color: review.textColor,
        width: "400px",
        padding: "20px",
        border: "none",
        transition: "all 0.3s ease-in-out",
        ...review.position,
      }}
    >
      <Card.Body>
        <FaQuoteRight
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            fontSize: "1.5rem",
            color: review.textColor === "#fff" ? "#FBB329" : "#ccc",
          }}
        />
        <div className="d-flex align-items-center mb-2">
          <img
            src={review.image}
            alt={review.name}
            className="rounded-circle me-3"
            width="50"
            height="50"
          />
          <div>
            <Card.Title className="mb-0">{review.name}</Card.Title>
            {review.time && <small className="text-muted">{review.time}</small>}
          </div>
          {getPlatformIcon(review.platform)}
        </div>
        <div className="mb-2">
          {[...Array(review.rating)].map((_, i) => (
            <FaStar key={i} className="text-warning" />
          ))}
        </div>
        <Card.Text>{review.text}</Card.Text>
      </Card.Body>
    </Card>
  );
};

const Testionomial = () => {
  return (
    <Container fluid className="why-choose-us-section">
      <Container className="position-relative py-5 my-5" style={{ height: "650px" }}>
        {/* Heading Section */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Testimonials</h2>

          <div
            className="mx-auto"
            style={{ width: "80px", height: "3px", background: "var(--Orange-Gold-color) !important" }}
          ></div>
        </div>

        {/* Center Round Image with Rating */}
        <div
          className="position-absolute text-center"
          style={{
            top: "38%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            border: "5px solid white",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            zIndex: "10",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        >
          <img
            src="https://randomuser.me/api/portraits/men/52.jpg"
            alt="Terry Mendez"
            className="w-100 h-100 rounded-circle"
          />
          <div className="mt-2">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="text-warning" />
            ))}
          </div>
        </div>

        {/* Review Cards */}
        {reviews.map((review, index) => (
          <ReviewCard key={index} review={review} />
        ))}
      </Container>
    </Container>
  );
};


export default Testionomial;
